module.exports = __webpack_public_path__ + "05_face.dcb1510b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer1/05_face.png
// module id = +xsf
// module chunks = 0